import { render, staticRenderFns } from "./ContactConversations.vue?vue&type=template&id=a65432fc&scoped=true&"
import script from "./ContactConversations.vue?vue&type=script&lang=js&"
export * from "./ContactConversations.vue?vue&type=script&lang=js&"
import style0 from "./ContactConversations.vue?vue&type=style&index=0&id=a65432fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65432fc",
  null
  
)

export default component.exports